import * as types from "./types";
import Vue from "vue";
import * as mutation_types from "./mutation_types";

export default {
    [types.A_QUOTES_SEARCH] ( context, payload ) {

      let countryTo = payload.countryTo;
      let citiesTo = payload.citiesTo;
      let hotels = payload.hotels.filter(x => x !== -1);
      let dates = payload.dates;
      let period = payload.period;

      let sendParams= `${context.state.API_URL}QuotedHotels/search?` +
      `countryKey=${countryTo}` + "&" +
      citiesTo.map(x => `cityKey=${x}`).join("&")+ "&" +
      hotels.map(x => `hotelsKey=${x}`).join("&")+ "&" +
      `dateFirst=${dates}`+ "&" +
      `period=${period}`;

      context.state.mainParams = `individuals/quotes/` +
      `countryKey=${countryTo}` + "&" +
      citiesTo.map(x => `cityKey=${x}`).join("&")+ "&" +
      hotels.map(x => `hotelsKey=${x}`).join("&")+ "&" +
      `dateFirst=${dates}`+ "&" +
      `period=${period}`;

      let URL = `?countryKey=${countryTo}` + "&" +
      `cityKey=${citiesTo}`+ "&" +
      `hotelsKey=${hotels}`+ "&" +
      `dateFirst=${dates}`+ "&" +
      `period=${period}`;

      context.state.urlParams = URL;
      context.state.showQuotes = true;

      return new Promise((resolve) => {
        Vue.Api.Get(sendParams)
          .then(res => {
            context.state.firstPageLoadFlag = false;
            context.state.lastRequest = sendParams;
            context.state.cashSearchResult = res.data;
            context.state.searchResult = res.data;

            context.commit(mutation_types.M_SET_SEARCHED, true);

            resolve(URL)
          })
      });
    },
    [types.A_SET_API_URL] ( context, payload ) {
      context.commit(mutation_types.M_SET_API_URL, payload)
    },
    [types.A_SET_API_ORIGIN] ( context, payload ) {
        context.commit(mutation_types.M_SET_API_ORIGIN, payload)
    },
};
